import React from "react";
import { SFStack, SFUseStyled } from "@sf-core";

const { styled } = SFUseStyled();

const StyledStack = styled(SFStack)(({ theme }) => ({
  marginRight: theme.spacing(1),
}));

const StyledDiv = styled("div", {
  shouldForwardProp: (prop) => prop !== "isSelected",
})(({ theme, isSelected }) => ({
  cursor: "pointer",
  borderRadius: theme.spacing(0.2),
  background: theme.palette.grey400.main,
  width: theme.spacing(2.5),
  height: theme.spacing(1),
  ...(isSelected && {
    background: theme.palette.blue300.main,
  }),
}));

const Levels = ({level, setLevel}) => {

  return (
    <StyledStack direction="row" spacing={0.5} alignItems="center">
      <StyledDiv isSelected={level >= 1} onClick={()=>setLevel(1)}/>
      <StyledDiv isSelected={level >= 2} onClick={()=>setLevel(2)}/>
      <StyledDiv isSelected={level >= 3} onClick={()=>setLevel(3)}/>
      <StyledDiv isSelected={level == 4} onClick={()=>setLevel(4)}/>
    </StyledStack>
  );
};

export default Levels;
